import { ColorTextLink, FontSize200 } from "@nxt-costco-com/forge-design-tokens";
const markdownStyles = {
  fontSize: FontSize200,
  lineHeight: "170%",
  a: {
    color: ColorTextLink,
    textDecoration: "none"
  }
};
const primaryButtonStyles = {
  width: "100%"
};
export {
  markdownStyles,
  primaryButtonStyles
};
